<template>
  <div>
    <CCol ref="content" xs="12" lg="12">
      <CCard>
        <CCardBody>
          <v-card
            style="padding-top: 20px; padding-left: 20px; padding-right: 20px; padding-bottom: 30px;"
            shaped
          >
            <GmapMap
              v-bind:center="center"
              v-bind:zoom="5"
              map-type-id="hybrid"
              ref="mapRef"
              :options="{
                zoomControl: true,
                mapTypeControl: true,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: true,
                disableDefaultUi: false,
              }"
              style="width: 100%; height: 600px"
            >
              <GmapMarker
                v-bind:key="index"
                v-for="(m, index) in markers"
                v-bind:position="m.position"
                :title="m.title"
                v-bind:clickable="true"
                v-bind:draggable="false"
                @click="profilePath(m.position, m.id)"
                :icon="{
                  url: require('../assets/icons/ico_marker.png'),
                  scaledSize: { width: 60, height: 50 },
                }"
              />
            </GmapMap>
          </v-card>
        </CCardBody>
      </CCard>
    </CCol>
  </div>
</template>

<script>
import { API_KEY } from "./API_KEY";
import { Loader, LoaderOptions } from "google-maps";
import router from "@/routes";
import Node from "../services/NodeData";

const loader = new Loader(API_KEY);

export default {
  data() {
    return {
      center: { lat: 32, lng: -7 },
      markers: [
        {
          position: { lat: "", lng: "" },
          title: "",
          id: "",
        },
      ],
    };
  },
  methods: {
    profilePath(position, id) {
      this.$refs.mapRef.$mapPromise.then((map) => {
        if (map.getZoom() < 12) 
        {

          map.panTo(position);
          map.setZoom(12);

        } else if (map.getZoom() == 12) 
        {
          map.panTo(position);
          map.setZoom(18);
        } else 
        {
          router.push(`/dashboard?id=${id}`);
        }
      });

      // router.push(`/dashboard?id=${id}`);
    },
  },
  mounted() {},
  created() {
    /*if(this.$store.state.Auth == false)
        router.push('/login')*/
    Node.getNodes().then((res) => {
      for (var i = 0; i < res.length; i++) {
        this.markers.push({
          position: {
            lat: parseFloat(res[i].latitude),
            lng: parseFloat(res[i].longitude),
          },
          title: res[i].FarmerName,
          id: res[i].NodeId,
        });
      }
    });
  },
};
</script>
